export default __webpack_public_path__ + "static/media/image_HitCreatingProject.34808024.svg";